var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
// eslint-disable-next-line import/no-extraneous-dependencies
import Axios from 'axios';
import { maskPhi } from '../utilities/phi';
import serviceUrls from './service-urls';
import { mapDatesFromApiResponse } from '../utilities/dates';
export function buildApi(_a) {
    var _this = this;
    var _b = _a === void 0 ? {
        baseURL: "".concat(serviceUrls.CORE_DOMAIN_API.BASE()),
        logoutUrl: "".concat(serviceUrls.WEB_ONCOLENS.BASE(), "/users/auth0_login"),
        doNotLogoutPaths: [],
    } : _a, _c = _b.baseURL, baseURL = _c === void 0 ? "".concat(serviceUrls.CORE_DOMAIN_API.BASE()) : _c, _d = _b.logoutUrl, logoutUrl = _d === void 0 ? "".concat(serviceUrls.WEB_ONCOLENS.BASE(), "/users/auth0_login") : _d, appendReturnUrl = _b.appendReturnUrl, _e = _b.doNotLogoutPaths, doNotLogoutPaths = _e === void 0 ? [] : _e;
    var config = {
        containsPHI: true,
    };
    var controller = new AbortController();
    var api = Axios.create(__assign({ withCredentials: true, baseURL: baseURL, timeout: 30000, signal: controller.signal }, config));
    api.defaults.timeout = 30000; // If you want to increase this, do it for a specific call, not the global app API.
    api.interceptors.response.use(function (response) { return response; }, function (error) { return __awaiter(_this, void 0, void 0, function () {
        var currentPath, logoutUrlExtended, isPHI;
        return __generator(this, function (_a) {
            if (controller.signal.aborted) {
                // eslint-disable-next-line prefer-promise-reject-errors
                return [2 /*return*/, Promise.reject('The request was aborted.')];
            }
            currentPath = "".concat(window.location.pathname).concat(window.location.search);
            if (error && error.response && error.response.status === 401) {
                console.error('Unauthorized. Logging out.', error);
                controller.abort();
                logoutUrlExtended = appendReturnUrl
                    ? appendReturnUrlToLogout(logoutUrl, currentPath, logoutUrl.startsWith('/'))
                    : logoutUrl;
                if (shouldLogout(doNotLogoutPaths)) {
                    window.location.assign(logoutUrlExtended);
                }
                return [2 /*return*/];
            }
            isPHI = error.config.containsPHI;
            if (isPHI === undefined || isPHI === null) {
                console.error("Name of URL: ".concat(error.toJSON().config.url || JSON.parse(error).config.url, " MISSING PHI FLAG: containsPHI. PLEASE SET."));
            }
            // eslint-disable-next-line no-param-reassign
            error.config.data = maskPhi(error.config.data, isPHI);
            if (isPHI) {
                // Something happened in setting up the request that triggered an Error
                console.error('client api request Error:', error.config.url);
            }
            else {
                console.error(error.config);
                if (error.response) {
                    // The request was made and the server responded with a status code
                    // that falls out of the range of 2xx
                    console.error(error.response.status, error.response.data, error.response.headers);
                }
                else if (error.request) {
                    // The request was made but no response was received
                    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                    // http.ClientRequest in node.js
                    console.error(error.request);
                }
            }
            console.error((error && error.toJSON && error.toJSON()) || undefined);
            return [2 /*return*/, Promise.reject(error)];
        });
    }); });
    return api;
}
var api = buildApi();
api.interceptors.response.use(function (response) {
    mapDatesFromApiResponse(response.data);
    return response;
});
var clients = {
    auth: buildApi({ baseURL: serviceUrls.AUTH.BASE(), appendReturnUrl: true }),
    admin: buildApi({ baseURL: "".concat(serviceUrls.ADMIN(), "/api"), appendReturnUrl: true }),
    domain: buildApi({ baseURL: "".concat(serviceUrls.CORE_DOMAIN_API.BASE(), "/api"), appendReturnUrl: true }),
};
function shouldLogout(doNotLogoutPaths) {
    return !doNotLogoutPaths.some(function (x) {
        return x.exact ? window.location.pathname === x.path : window.location.pathname.startsWith(x.path);
    });
}
function appendReturnUrlToLogout(logoutUrl, currentPath, relative) {
    if (relative === void 0) { relative = false; }
    var url = relative ? new URL(logoutUrl, window.location.origin) : new URL(logoutUrl);
    if (!url.searchParams.has('returnUrl')) {
        url.searchParams.append('returnUrl', currentPath);
    }
    return relative ? "".concat(url.pathname).concat(url.search) : url.href;
}
export { api as default, clients };
